module.exports = __webpack_public_path__ + "files/26a35b430a1a2bfba9d80e270824f390.png";